export default function() {
    $('.js-even-height').each(function(){
        var heights = [];
        $(this).find('.js-item').each(function(){
            heights.push( $(this).outerHeight() );
        });
        var biggestHeight = Math.max.apply( null, heights );
        $(this).find('.js-item').css('min-height', biggestHeight);
    });

}
